import { AccessCode } from './AccessCode';
import { BillingPeriod } from './BillingPeriod';
import { Charge } from './Charge';
import { Company } from './Company';
import { CourseSection } from './CourseSection';
import { Currency } from './Currency';
import { Edition, translateEditionForTransport, translateEditionFromTransport } from './Edition';
import { Enrollment } from './Enrollment';
import { Item } from './Item';
import { Person } from './Person';
import { Price, translatePriceForTransport, translatePriceFromTransport } from './Price';
import { Term } from './Term';

export enum TransactionType {
  EDITION = 'EDITION',
  ENROLLMENT = 'ENROLLMENT',
}

export interface Transaction extends Item {
  type: TransactionType;
  amount?: number;
  currency: Currency;
  editionId?: number;
  edition?: Edition;
  enrollmentId?: number;
  enrollment?: Enrollment;
  refundId?: number;

  refundById?: number;
  refundBy?: Person;

  refund?: Transaction;
  refundDate?: Date;
  invoiceDate?: Date;
  paymentDate?: Date;
  charges?: Charge[];
  priceId: number;
  price?: Price;
  billingPeriodId?: number;
  billingPeriod?: BillingPeriod;
  originalTransactionId?: number;
  originalTransaction?: Transaction;
  accessCodeId?: number;
  accessCode?: AccessCode;

  schoolId?: number;
  school?: Company;

  termId?: number;
  term?: Term;

  courseSectionId?: number;
  courseSection?: CourseSection;

  voidBy?: string;
  voidAt?: Date;
}

export const displayTransactionType = (transactionType?: TransactionType) => {
  switch (transactionType) {
    case TransactionType.EDITION:
      return 'Edition';
    case TransactionType.ENROLLMENT:
      return 'Enrollment';
    default:
      return '-';
  }
};

export const displayTransactionAmount = (transaction?: Transaction) => {
  if (transaction?.amount && !isNaN(transaction.amount)) {
    const addPlus = transaction.amount > 0 ? '+' : '';

    return `${addPlus}${Number(transaction.amount).toFixed(2)} ${transaction.currency}`;
  } else {
    return '-';
  }
};

export const displayTransaction = (transaction?: Transaction) => {
  if (transaction?.amount && !isNaN(transaction.amount)) {
    return `${Number(transaction.amount).toFixed(2)} ${transaction.currency}`;
  } else {
    return '-';
  }
};

export const translateTransactionForTransport = (attributes: any): any => {
  let response = { ...attributes };

  if (attributes.edition) {
    response = {
      ...response,
      edition: translateEditionForTransport(attributes.edition),
    };
  }

  if (attributes.price) {
    response = {
      ...response,
      price: translatePriceForTransport(attributes.price),
    };
  }

  return response;
};

export const translateTransactionFromTransport = (attributes: any): any => {
  let response = { ...attributes };

  if (attributes.edition) {
    response = {
      ...response,
      edition: translateEditionFromTransport(attributes.edition),
    };
  }

  if (attributes.price) {
    response = {
      ...response,
      parentProduct: translatePriceFromTransport(attributes.price),
    };
  }

  return response;
};
